import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { CwButton, CwDialog } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { DialogHelperService } from '@/app/shared/ui-common/dialog/dialog-helper/dialog-helper.service';
import { DialogSizes } from '@/app/shared/ui-common/dialog/dialog.constants';

@Component({
  selector: 'app-dialog',
  imports: [CwDialog, CwButton, NgTemplateOutlet, TranslocoDirective, NgComponentOutlet],
  templateUrl: './dialog.component.html',
})
export class DialogComponent {
  readonly dialogHelper = inject(DialogHelperService);

  dialog = toSignal(this.dialogHelper.dialog$);

  close(result = false) {
    this.dialogHelper.close(result);
  }

  protected readonly DialogSizes = DialogSizes;
}
